// @ts-nocheck
import React from 'react';
import { ConfirmDeleteDialog } from '../../../components/ConfirmDeleteDialog';
import type { DeploymentItem } from '../../../api/deploymentsApi';

interface DeploymentItemDeleteDialogProps {
  item: DeploymentItem | null;
  open: boolean;
  loading?: boolean;
  error?: string | null;
  onConfirm: () => void;
  onClose: () => void;
}

export const DeploymentItemDeleteDialog = ({
  item,
  open,
  loading = false,
  error = null,
  onConfirm,
  onClose,
}: DeploymentItemDeleteDialogProps) => {
  if (!item) return null;

  const date = `${item.scheduled_date}${
    item.scheduled_time ? ` ${item.scheduled_time}` : ''
  }`;

  return (
    <ConfirmDeleteDialog
      open={open}
      title="Supprimer cet item ?"
      description="Cette action est définitive. L'item suivant sera retiré du déploiement :"
      details={[
        { label: 'PDV', value: item.store_name, emphasis: true },
        { label: 'Marque', value: item.brand },
        { label: 'Mobilier', value: item.furniture_name },
        { label: 'Date', value: date },
      ]}
      loading={loading}
      error={error}
      onConfirm={onConfirm}
      onClose={onClose}
    />
  );
};
